import ActionButton from '@repo/ui/action-button'
import { DragHandleProps } from '@repo/ui/draggable-list'
import { CheckMarkIcon, DragIcon, XIcon } from '@repo/ui/icons'
import Input from '@repo/ui/input'
import { useState } from 'react'

interface LanguageTestSectionCreateCardProps {
  isDragging?: boolean
  dragHandleProps?: DragHandleProps
  onConfirm: (label: string) => void
  onCancel: () => void
  isLoading?: boolean
}

const LanguageTestSectionCreateCard = ({
  isDragging,
  dragHandleProps,
  onConfirm,
  onCancel,
  isLoading = false
}: LanguageTestSectionCreateCardProps) => {
  const [sectionLabel, setSectionLabel] = useState('')

  const handleConfirm = () => {
    if (sectionLabel.trim()) {
      onConfirm(sectionLabel.trim())
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleConfirm()
    } else if (e.key === 'Escape') {
      onCancel()
    }
  }

  return (
    <div
      className={`flex items-center gap-3 p-4 bg-white border border-primary-light rounded-lg shadow-sm transition-shadow ${isDragging ? 'shadow-lg opacity-75' : ''}`}
    >
      {/* Drag Handle - Only this part is draggable */}
      <div
        {...dragHandleProps?.attributes}
        {...dragHandleProps?.listeners}
        style={dragHandleProps?.style}
        className="flex items-center justify-center w-6 h-6 text-gray-300 cursor-default"
      >
        <DragIcon className="scale-125" />
      </div>

      <div className="flex-1 flex items-center gap-3">
        <div className="flex-1">
          <Input
            type="text"
            placeholder="Nom de la section"
            value={sectionLabel}
            onChange={(e) => setSectionLabel(e.target.value)}
            onKeyDown={handleKeyPress}
            autoFocus
            disabled={isLoading}
          />
        </div>

        <div className="flex items-center gap-2">
          <ActionButton variant="danger" icon={XIcon} onClick={onCancel} disabled={isLoading} />
          <ActionButton
            variant="primary"
            isLoading={isLoading}
            icon={CheckMarkIcon}
            onClick={handleConfirm}
            disabled={isLoading || !sectionLabel.trim()}
          />
        </div>
      </div>
    </div>
  )
}

export default LanguageTestSectionCreateCard
